
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './style.css';
import Heder from './Components/Heder';

function App() {
  return (
    <>
      <Heder />
    </>
  );
}

export default App;
